import { useCallback, useEffect, useState } from 'react';

import { API } from '../../../../network/api';

const checkEmail = (value) => {
  const regex = /^[\w\s@.!#$%&'*+/=?^_`{|}~-]+@[^\s@]+$/;
  return regex.test(value);
};

const useUsersInfo = ({
  country,
  currentPage,
  pageSize,
  searchedName,
  role,
  sortConfig,
}) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [total, setTotal] = useState(0);

  const searchedValue = searchedName?.trim();
  const { column, order } = sortConfig || {};

  const fetchUsers = useCallback(async () => {
    setData(null);
    setError(null);
    setLoading(true);
    setTotal(0);
    try {
      const params = {
        page: currentPage - 1,
        size: pageSize,
        ...(role && { 'role.equals': role }),
        ...(country && { 'country.equals': country }),
        ...(searchedValue &&
          !checkEmail(searchedValue) && { 'name.contains': searchedValue }),
        ...(searchedValue &&
          checkEmail(searchedValue) && { 'email.contains': searchedValue }),
        ...(column && order && { sort: `${column},${order}` }),
      };
      const res = await API.get(`user/search`, { params });

      if (!res?.data) {
        setError(
          'Error occured while trying to fetch users information. Please try again',
        );
        return;
      }
      if (res?.data?.length === 0) {
        setError('No data available');
        return;
      }
      if (res.headers?.get('X-Total-Count')) {
        setTotal(parseInt(res.headers.get('X-Total-Count')));
      }
      setData(res.data);
    } catch (err) {
      setError(err?.message || 'Something went wrong!');
    } finally {
      setLoading(false);
    }
  }, [country, currentPage, pageSize, role, searchedValue, column, order]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return {
    data,
    isLoading,
    error,
    total,
    refetch: fetchUsers,
  };
};

export default useUsersInfo;
